export default __webpack_public_path__ + "static/media/6104.505d646a.svg";